export const AR = 'Additional Resource';
